import * as React from 'react';


export default class Diary extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg id="diaries" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
        <g id="left-nav-primary-icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-337.000000, -133.000000)">
            <g id="Group-7" transform="translate(337.000000, 133.000000)">
                <g id="Group-2-Copy-3" transform="translate(4.000000, 3.000000)">
                    <path d="M5.45454545,1.36363636 L5.45454545,0.909090909 C5.45454545,0.407013864 5.86155932,9.2230057e-17 6.36363636,0 L15.4545455,0 C15.9566225,-9.2230057e-17 16.3636364,0.407013864 16.3636364,0.909090909 L16.3636364,15.4545455 C16.3636364,15.9566225 15.9566225,16.3636364 15.4545455,16.3636364 L9.86902928,16.3636364 L9.86902928,15 L15,15 L15,1.36363636 L5.45454545,1.36363636 Z" id="Rectangle-3-Copy-6" fill="#FFFFFF" fillRule="nonzero"></path>
                    <path d="M1.36363636,15 L2.14175655,15 L2.14175655,16.3636364 L0.909090909,16.3636364 C0.407013864,16.3636364 6.14867046e-17,15.9566225 0,15.4545455 L1.00929366e-16,0.909090909 C3.94426612e-17,0.407013864 0.407013864,9.2230057e-17 0.909090909,0 L11.8181818,0 C12.3202589,-9.2230057e-17 12.7272727,0.407013864 12.7272727,0.909090909 L12.7272727,15.4545455 C12.7272727,15.9566225 12.3202589,16.3636364 11.8181818,16.3636364 L9.86902928,16.3636364 L9.86902928,15 L11.3636364,15 L11.3636364,1.36363636 L1.36363636,1.36363636 L1.36363636,15 Z" id="Rectangle-3-Copy-7" fill="#FFFFFF" fillRule="nonzero"></path>
                    <g id="Path-2">
                        <use fill="#FFFFFF" fillRule="evenodd"></use>
                        <path stroke="#FFFFFF" strokeWidth="1.5" d="M4.38636364,13.4772727 L4.38636364,17.9284625 L5.90909091,16.1011898 L7.43181818,17.9284625 L7.43181818,13.4772727 L4.38636364,13.4772727 Z"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
